import React from "react";
import './MenuNavbar.scss';
import { useSelector } from "react-redux";
import menu from "../../assets/arrow-right.svg"
import config from "react-global-configuration";
import { useHistory } from "react-router";

const MenuNavbarMini = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const history = useHistory()
    return (
        <div className='Hospitality-Menu-Nav'>
            <div className="Hospitality-navbar-fixed-header">
                <div className='Hospitality-navbar-mini-logo'>
                    <img
                        className="arrow-icon-cont"
                        src={menu}
                        alt="Menu Icon"
                        onClick={() => {
                            history.goBack()
                        }}
                    />
                    <div className="Hospitality-navbar-logo">

                        <a
                            className="eco-navbar-logo"
                            href={!restaurantDataState.hasResturantWidget && `/`}
                        >
                            <img
                                style={{ maxHeight: "48px" }}
                                src={config.get("companyLogo")}
                                draggable="false"
                            />
                        </a>
                    </div>
                </div>
            </div></div>
    )
}
export default MenuNavbarMini